import {
	Directive,
	HostListener,
	Input,
	Optional
} from '@angular/core';
import { VgControlsComponent } from 'vbrick-player-src/videogular/controls/VgControls.Component';

@Directive({
	selector: '[vbControlBarFocus]',
})
export class VbControlBarFocusDirective {
	@Input() public disableControlBarFocus: boolean;

	constructor(
		@Optional() private vgControl: VgControlsComponent,
	){}

	@HostListener('focus')
	public onFocus(): void {
		if (this.disableControlBarFocus) {
			return;
		}
		this.vgControl.showControls();
	}
}
